const chevrolet = {
  state: () => ({
    images: {
      sedans: [
        {
          modelName: "Cruze",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Cruze2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/cruze-19.png"),
          trims: ["L", "LS", "LT", "Premier"]
        },
        {
          modelName: "Impala",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Impala2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/impala-19.png"),
          trims: ["LT", "Premier"]
        },
        {
          modelName: "Malibu",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Malibu2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/malibu-21.png"),
          trims: ["L", "LS", "RS", "LT", "Premier"]
        },
        {
          modelName: "Sonic",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Sonic2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/sonic-20.png"),
          trims: ["LS", "LT Sedan", "LT Hatch", "Premier Sedan", "Premier Hatch"]
        },
        {
          modelName: "Spark",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Spark2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/spark-22.png"),
          trims: ["LS", "1LT", "ACTIV", "2LT"]
        },
      ],
      suvs: [
        {
          modelName: "Blazer",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Blazer2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/blazer-22.png"),
          trims: ["L", "1LT", "2LT", "3LT", "RS", "Premier"]
        },
        {
          modelName: "Equinox",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Equinox2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/equinox-21.png"),
          trims: ["L", "LS", "LT", "Premier"]
        },
        {
          modelName: "Suburban",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Suburban2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/suburban-21.png"),
          trims: ["LT", "Z71", "Premier", "High Country"]
        },
        {
          modelName: "Tahoe",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Tahoe2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/tahoe-21.png"),
          trims: ["LS", "LT", "RST", "Z71", "Premier", "High Country"]
        },
        {
          modelName: "Traverse",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Traverse2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/traverse-21.png"),
          trims: ["L", "LS", "LT Cloth", "LT Leather", "RS", "Premier", "High Country"]
        },
        {
          modelName: "Trax",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Trax2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/trax-2022.png"),
          trims: ["LS", "LT"]
        },
      ],
      trucks: [
        {
          modelName: "Colorado",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Colorado2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/colorado-21.png"),
          trims: ["WT", "LT", "Z71", "ZR2"]
        },
        {
          modelName: "Silverado",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Silverado2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/silverado1500-20.png"),
          trims: ["WT", "Custom", "Custom Trail Boss", "LT", "RST", "LT Trail Boss", "LTZ", "High Country"]
        },
      ],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/chevrolet/lifestyle/chevy-multivehicle.jpg"),
        sedanImage: require("../../../static/images/carcuts/chevrolet/lifestyle/chevy-cruze3.jpg"),
        suvImage: require("../../../static/images/carcuts/chevrolet/lifestyle/blazer-20.jpg"),
        truckImage: require("../../../static/images/carcuts/chevrolet/lifestyle/silverado-19.jpg")
      },
      videoLink: [
        "https://player.vimeo.com/external/309114820.hd.mp4?s=882171e11cc78556d4b959a84f39cf577f765845&profile_id=175"
      ],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/chevy-New.png"), require("../../../static/images/buttons/round-buttons/chevy-Used.png"), require("../../../static/images/buttons/round-buttons/chevy-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/chevy-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/chevy-new.png"), require("../../../static/images/buttons/browse-buttons/chevy-used.png"), require("../../../static/images/buttons/browse-buttons/chevy-service.png"), require("../../../static/images/buttons/browse-buttons/chevy-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/chevy01.png"), require("../../../static/images/buttons/swoop-icons/chevy03.png"), require("../../../static/images/buttons/swoop-icons/chevy02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/chevy/CM-JN-24-Chevy-Established.jpg"), require("../../../static/images/banners/chevy/CM-JN-24-Chevy-Lifestyle.jpg"), require("../../../static/images/banners/chevy/CM-JN-24-Chevy-Modern.jpg"), require("../../../static/images/banners/chevy/CM-JN-24-Chevy-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/chevy/SOKAL-SRS-Chevy-120921-DealerDraft-Established.jpeg"), require("../../../static/images/banners/chevy/SOKAL-SRS-Chevy-120921-DealerDraft-Lifestyle.jpeg"), require("../../../static/images/banners/chevy/SOKAL-SRS-Chevy-120921-DealerDraft-Modern.jpeg"), require("../../../static/images/banners/chevy/SOKAL-SRS-Chevy-120921-DealerDraft-Playful.jpg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-chevy.png"),
        require("../../../static/images/buttons/logos/dd-logo-chevy-w.png")
      ]
    },
   colors: {
      "--primary-color": "#cd9834",
      "--primary-dark": "#393839",
      "--primary-light": "#FFF",
      "--secondary-color": "#787c81",
      "--secondary-dark": "#393839",
      "--secondary-light": "#97989a",
    },
    fonts: {
      "--heading-text": "Louis-Bold, 'Helvetica Neue', Arial, sans-serif",
      "--subheading-text": "Louis-Bold, 'Helvetica Neue', Arial, sans-serif",
      "--body-text": "'Roboto', 'Helvetica Neue', Arial, sans-serif",
      "--bold-text": "'Roboto', 'Helvetica Neue', Arial, sans-serif"
    }
  })
}


export default chevrolet